import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { CenteredScrollableContentModule } from '@sdbn/tmc-common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VisitorTypeRelatedImageComponent } from './component/visitortype-related-image.component';


@NgModule({
  declarations: [
    VisitorTypeRelatedImageComponent
  ],
  imports: [
    CommonModule,
    CenteredScrollableContentModule,
    DictionaryModule,

    FormsModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
  ]
})
export class VisitorTypeRelatedImageModule { }
